import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default function staggeredSlideUp(
    el: Element,
    containerEl: HTMLElement | null,
    isMarkersEnabled: boolean
): void {
    gsap.registerPlugin(ScrollTrigger);

    const triggerEl = containerEl || el;

    const scrollTriggerOptions = {
        trigger: triggerEl,
        scrub: 1,
        start: 'clamp(top 100%)',
        end: 'clamp(60% 80%)',
        markers: isMarkersEnabled,
        toggleActions: 'restart none none none',
    };

    const mm = gsap.matchMedia();

    mm.add('(prefers-reduced-motion: no-preference)', () => {
        const tl = gsap.timeline();
        tl.from(triggerEl, { autoAlpha: 0 }).from(el.children, {
            y: 150,
            opacity: 0.5,
            stagger: 0.1,
            duration: 0.5,
            scrollTrigger: scrollTriggerOptions,
        });
    });
    mm.add('(prefers-reduced-motion: reduce)', () => {
        const tl = gsap.timeline();
        tl.from(triggerEl, { autoAlpha: 0 });
    });
}
